import type { PayloadAction } from '@reduxjs/toolkit'
import { createSlice } from '@reduxjs/toolkit'

import { mapToPlanMetrics, mapToUserPlanTracker, OrgPlanTracker, PlanMetrics, UserPlanTracker } from '../models/plan-metrics.model'
import { ProfileModel } from '../models/profile.model'

import { RoleModel } from '../models/roles.model'
import { Setting, SettingsModel } from '../models/settings-model'
import { SecureDocModel } from '../models/secure-docs.model'
import { OrganizationModel, SmsUserDetailsModel, UserModel } from '../models/users.model'
import { AppState } from './models'
import { UserService } from '../services/UserService'
import { SettingsService } from '../services/SettingsService'
import { SecureDocsStatusModel } from '../models/secure-docs-status'


const initialState: AppState = {
    userRoleId: UserService.getLoggedInUserRole() ?? 0,
    Users: [],
    User: {
        ID: '',
        Email: '',
        FirstName: '',
        LastName: '',
        FullName: '',
        OrganizationID: '',
        OrganizationName: '',
        RoleID: 0,
        UserStatus: 0,
        ImageReferenceId: '',
        SignUpMethod: 0,
        AddedBy: '',
        Signature: {
            IsEnabledSign: false,
            Value: ''
        },
        Timezone: {
            IsDefaultTimezone: false,
            SelectedTimeZone: ''
        },
        NotificationEnabled: false,
        CreatedDateTime: '',
        UpdatedDateTime: '',
        Channel_Wishlist: [],
        EmailNotifcation: false
    },
    AllUsers: [],
    Settings: {
        AllowedWrongPasswordAttempts: 0,
        NotificationsEnabled: false,
        TwoFactAuthEnabled: false,
        UnSubscribeStopEnabled: false,
        BlockIncomingMMSEnabled: false,
        BlockIncomingMessageLinksEnabled: false,
        Settings: [],
        VoiceVerificationEnabled: true,
    } as SettingsModel,
    Profile: {
        FullName: 'U K',
        Email: '',
        FirstName: '',
        ImageReferenceId: '',
        LastName: '',
        PhoneNumber: '',
        OrganizationName: '',
        OrgId: JSON.parse(localStorage.getItem("current-user")?.toString() || "{}")
            ?.organizationId || '',
        RoleID: '',
    } as ProfileModel,
    IsMobileDevice: window.outerWidth <= 835,
    ShowSideMenu: false,
    IsTeamsApp: window.location.pathname.includes('teams'),
    DeviceWidth: window.outerWidth,
    DeviceHeight: window.innerHeight,
    Roles: [],
    Plans: [],
    PlanDetails: {
        PlanId: "",
        PLanName: "",
        Status: null,
        Price: "",
        Features: [],
        FeatureKeys: [],
        Quantity: 0,
        AddOns: [],
        IsReccuring: false,
        IsMonthly: false,
        IsYearly: false,
        Created_At: "",
        Last_Updated_At: "",
        Start_Date: "",
        End_Date: ""
    },

    LoadingSecureDocs: false,
    LoadedSecureDocs: false,

    IsMassContactsDeletionInProgress: false,
    IsMassGroupsDeletionInProgress: false,
    HandleMassContactsActionEvent: false,
    HandleMassGroupsActionEvent: false,

    PlanMetrics: mapToPlanMetrics(
        JSON.parse(localStorage.getItem("current-user")?.toString() || "{}").planTracker
    ),
    ShowingAlertsCount: 0,
    Toasts: [],

    WebNotificationText: {},
    OrganizationName: "",
    SecureDocs: [],
    HeaderSelectedCount: 0,
    isSignalRConnected: false,
    LoadingProfile: false,
    isDarkMode: false,
    UserPlanTracker: undefined,
    OrgPlanTracker: undefined,
    SecureDocsStatus: {
        total_files: null,
        completed_files: 0,
        total_recipients: 0,
        incompleted_files: 0,
        recent_activity: []
    },
    isLoading: false,
    SysAdminAllOrganizations: [],
    SysAdminAllUsers: [],
    ISSmsLogin: false,
    isNewOrganization: false,
    SmsNotificationStatus: false,
    SmsUserDetails: {
        FirstName: '',
        LastName: '',
        OrganizationName: '',
        PhoneNumber: '',
        PhoneNumberID: ''
    } as SmsUserDetailsModel,
}

const counterSlice = createSlice({
    name: 'appRedeucer',
    initialState,
    reducers: {
        updateUserRoleId: (state: AppState, action: PayloadAction<number>) => {
            state.userRoleId = action.payload
        },

        updatePlanMetrics: (state: AppState, action: PayloadAction<PlanMetrics>) => {
            state.PlanMetrics = { ...action.payload } as PlanMetrics;
        },

        updateOrgName: (state: AppState, action: PayloadAction<ProfileModel>) => {
            state.OrganizationName = action.payload as any;
        },

        updateUserProfile: (state: AppState, action: PayloadAction<UserModel>) => {
            state.User = action.payload;
        },

        updateMenuFlag: (state: AppState, action: PayloadAction<boolean>) => {
            state.ShowSideMenu = action.payload
        },

        updateMobileDevice: (state: AppState) => {
            let width = window.outerWidth < 320 ? window.innerWidth : window.outerWidth
            state.IsMobileDevice = width <= 835 && width !== 0;
            state.DeviceWidth =
                width < 320
                    ? state.DeviceWidth < 320
                        ? 320
                        : state.DeviceWidth
                    : width;
            state.DeviceHeight = window.innerHeight
        },

        updateRoles: (state: AppState, action: PayloadAction<RoleModel[]>) => {
            state.Roles = action.payload;
        },

        headerTitle: (state: AppState, action) => {
            state.HeaderTitle = action.payload;
            state.HeaderCount = undefined;
            state.RefreshHandler = undefined;
            state.BackHandler = undefined
        },

        headerCount: (state: AppState, action: PayloadAction<number>) => {
            state.HeaderCount = action.payload
        },

        headerSelectedCount: (state: AppState, action) => {
            state.HeaderSelectedCount = action.payload;
        },

        refreshHandler: (state: AppState, action) => {
            state.RefreshHandler = action.payload
        },

        backHandler: (state: AppState, action) => {
            state.BackHandler = action.payload;
        },

        setPlans: (state: AppState, action) => {
            state.Plans = action.payload;
        },

        setShowingAlert: (state: AppState, action: PayloadAction<number>) => {
            state.ShowingAlertsCount = action.payload
        },

        updateMassContactsDeletionInProgess: (state, action) => {
            state.IsMassContactsDeletionInProgress = action.payload
        },

        handleMassContactsActionEvent: (state, action) => {
            state.HandleMassContactsActionEvent = action.payload
        },

        updateMassGroupsDeletionInProgess: (state, action) => {
            state.IsMassGroupsDeletionInProgress = action.payload
        },

        handleMassGroupsActionEvent: (state, action) => {
            state.HandleMassGroupsActionEvent = action.payload
        },

        //toaster functions
        setToasts: (state, action) => {
            state.Toasts = [
                {
                    ID: action.payload.id,
                    Text: action.payload.text,
                    Timeout: action.payload.timeout,
                    Type: action.payload.type,
                    Hide: true,
                },
                ...state.Toasts
            ]
        },
        showToast: (state, action) => {
            let x = state.Toasts.find((x) => x.ID === action.payload.id)
            if (x) {
                x.Hide = false
            }

        },
        hideToast: (state, action) => {
            let x = state.Toasts.find((x) => x.ID === action.payload.id)
            if (x) {
                x.Hide = true
            }
        },
        clearToast: (state, action) => {
            state.Toasts = state.Toasts.filter((x) => x.ID !== action.payload.id)
        },

        HandleWebNotication: (state, action) => {
            state.WebNotificationText = action.payload
        },

        updateChannelTemplates: (state, action) => {
            return {
                ...state,
                ChannelTemplates: action.payload,
            }
        },

        updateFaceboolTemplates: (state, action) => {
            return {
                ...state,
                FacebookTemplates: action.payload,
            }
        },

        updatePlanDetails: (state: AppState, action) => {
            state.PlanDetails = action.payload
        },

        updateSecureDocs: (state: AppState, action: PayloadAction<SecureDocModel[]>) => {
            state.SecureDocs = action.payload;
            state.LoadingSecureDocs = false;
            state.LoadedSecureDocs = true;
        },

        updateLoadingSecureDocs: (state: AppState, action: PayloadAction<boolean>) => {
            state.LoadingSecureDocs = action.payload
        },

        updateSignalRConnectionConnectionState: (state: AppState, action: PayloadAction<boolean>) => {
            state.isSignalRConnected = action.payload;
        },

        updateSettings: (state: AppState, action) => {
            state.Settings = {
                ...state.Settings,
                Settings: action.payload,
                AllowedWrongPasswordAttempts: parseInt(
                    action.payload?.find(
                        (x: Setting) =>
                            x.Code === SettingsService.Wrong_Password_Attmps_Code
                    )?.Value || state.Settings?.AllowedWrongPasswordAttempts
                ),
                NotificationsEnabled: action.payload?.find(
                    (x: Setting) => x.Code === SettingsService.Notification_Code
                )
                    ? action.payload
                        ?.find(
                            (x: Setting) => x.Code === SettingsService.Notification_Code
                        )
                        .Value?.toLowerCase() === 'true'
                    : state.Settings.NotificationsEnabled,
                TwoFactAuthEnabled: action.payload?.find(
                    (x: Setting) => x.Code === SettingsService.Two_FactAuth_Code
                )
                    ? action.payload
                        ?.find(
                            (x: Setting) => x.Code === SettingsService.Two_FactAuth_Code
                        )
                        ?.Value.toLowerCase() === 'true'
                    : state.Settings.TwoFactAuthEnabled,
                VoiceVerificationEnabled: action.payload?.find(
                    (x: Setting) => x.Code === SettingsService.Voice_Otp_Veification
                )
                    ? action.payload
                        ?.find(
                            (x: Setting) =>
                                x.Code === SettingsService.Voice_Otp_Veification
                        )
                        .Value?.toLowerCase() === 'true'
                    : state.Settings?.VoiceVerificationEnabled,
            }

            let setTimeZone = action.payload?.find(x => x.Code === SettingsService.Auto_Time_Zone_Code)?.Value?.toString()?.toLowerCase() === "false" ? action.payload?.find(x => x.Code === SettingsService.Time_Zone_Code)?.Value?.toString() : ""
            localStorage.setItem("Timezone", setTimeZone)
        },

        updateUserPlanMetrics: (state: AppState, action: PayloadAction<UserPlanTracker>) => {
            const data = mapToUserPlanTracker(action.payload, state.Settings.Settings)
            state.UserPlanTracker = data as UserPlanTracker;
        },

        updateOrgPlanMetrics: (state: AppState, action: PayloadAction<OrgPlanTracker>) => {
            state.OrgPlanTracker = { ...action.payload } as OrgPlanTracker;
        },

        updateUsers: (state: AppState, action: PayloadAction<UserModel[]>) => {
            state.Users = action.payload;
        },

        updateSecureDocsStatusModel: (state: AppState, action: PayloadAction<SecureDocsStatusModel>) => {
            state.SecureDocsStatus = action.payload;
        },

        updateAllOrganizations: (state: AppState, action: PayloadAction<OrganizationModel[]>) => {
            state.SysAdminAllOrganizations = action.payload;
        },

        updateAllUsers: (state: AppState, action: PayloadAction<UserModel[]>) => {
            state.SysAdminAllUsers = action.payload;
        },

        updateIsLoading: (state: AppState, action: PayloadAction<boolean>) => {
            state.isLoading = action.payload;
        },

        UpdateISSmsUser: (state: AppState, action: PayloadAction<boolean>) => {
            state.ISSmsLogin = action.payload
        },

        UpdateSmsUserDetails: (state: AppState, action: PayloadAction<SmsUserDetailsModel>) => {
            state.SmsUserDetails = action.payload
        },

        updateISNewOrganization: (state: AppState, action: PayloadAction<boolean>) => {
            state.isNewOrganization = action.payload;
        },

        updateSmsNotificationStatus: (state, action) => {
            state.SmsNotificationStatus = action.payload
        },

    },
})

export const {
    updateUserRoleId,
    updateSecureDocsStatusModel,
    updateUsers,
    updatePlanMetrics,

    updateRoles,

    updateMobileDevice,
    updateOrgName,

    updateMenuFlag,

    backHandler,
    headerCount,
    headerSelectedCount,
    headerTitle,
    refreshHandler,

    setShowingAlert,

    updateMassContactsDeletionInProgess,
    updateMassGroupsDeletionInProgess,

    clearToast,
    hideToast,
    setToasts,
    showToast,
    HandleWebNotication,

    updateChannelTemplates,
    updateFaceboolTemplates,
    setPlans,
    updatePlanDetails,
    handleMassContactsActionEvent,
    handleMassGroupsActionEvent,
    updateSecureDocs,
    updateLoadingSecureDocs,
    updateSignalRConnectionConnectionState,
    updateSettings,
    updateUserPlanMetrics,
    updateOrgPlanMetrics,
    updateAllOrganizations,
    updateAllUsers,
    updateUserProfile,
    updateIsLoading,
    UpdateISSmsUser,
    UpdateSmsUserDetails,
    updateISNewOrganization,
    updateSmsNotificationStatus
} = counterSlice.actions

export default counterSlice.reducer